module.exports = __webpack_public_path__ + "static/media/checkmark_green.a0fd83da.svg";